import React from 'react'
import { isEmpty } from 'lodash'

import Dropdown from '@ublique/components/Dropdown'
import TextInput from '@ublique/components/TextInput'
import MultiSelect from '@ublique/components/MultiSelect'

import './index.scss'

// TODO add the touched handler
const FormField = React.memo(
  ({
    t,
    id,
    name,
    labelText,
    label,
    placeholder,
    value,
    handleChange,
    isDisabled,
    isInvalid,
    invalidText,
    type,
    itemsList,
    selectedItem,
    initialSelectedItems,
    customLabelText,
    direction = 'bottom'
  }) => {
    if (type === 'text') {
      return (
        <div className='text-input'>
          {customLabelText && (
            <div className='custom-label-text'>
              <span>{t(customLabelText)}</span>
            </div>
          )}
          <TextInput
            id={id}
            onChange={handleChange}
            name={name}
            labelText={t(label)}
            // placeholder={t(placeholder)}
            value={value}
            invalidText={t(invalidText)}
            invalid={isInvalid}
            disabled={isDisabled}
            light
            type={type}
            autocomplete='new-password'
          />
        </div>
      )
    }
    if (type === 'multiselect') {
      return (
        <div className='multiselect-input'>
          <MultiSelect
            id={id}
            ariaLabel='MultiSelect'
            useTitleInItem={false}
            initialSelectedItems={!isEmpty(value) ? value : []}
            titleText={t(label)}
            label={t(label)}
            light
            invalidText={t(invalidText)}
            invalid={isInvalid}
            disabled={isDisabled}
            name={name || id}
            value={value}
            onChange={handleChange}
            direction={direction}
            items={itemsList}
            itemToString={(item) => (item ? t(item.label) : '')}
          />
        </div>
      )
    }
    if (type === 'select') {
      return (
        <div className='multiselect-input'>
          <Dropdown
            id={id}
            ariaLabel='Dropdown'
            titleText={t(labelText)}
            label={t(labelText)}
            placeholder={t(placeholder)}
            light
            selectedItem={selectedItem?.value ? selectedItem : null}
            invalidText={t(invalidText)}
            invalid={isInvalid}
            disabled={isDisabled}
            onChange={handleChange}
            name={name || id}
            items={itemsList}
            itemToString={(item) => (item ? t(item.label) : '')}
          />
        </div>
      )
    }
    return null
  }
)

const DefaultForm = ({ t, formFields, permissionType }) => {
  return (
    <div className='default-form'>
      {formFields.map((field) => (
        <FormField
          {...field}
          t={t}
          key={field.id}
          permissionType={permissionType}
        />
      ))}
    </div>
  )
}

export default DefaultForm
